import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export default new Echo({
  client: Pusher,
  broadcaster: 'pusher',
  key: '43c5d15ed5848d5c1c37',
  cluster: 'eu',
  encrypted: true
})
